/**
 * @generated SignedSource<<1dee97f23da0bb8e4be6d54ba8f26a6e>>
 * @relayHash 3e4fce2a05f5bb4df3e41b39cf958b48
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 3e4fce2a05f5bb4df3e41b39cf958b48

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      }
    ],
    "concreteType": "DeclarativeAnnexeOrOutstandingCheckMutationResponse",
    "kind": "LinkedField",
    "name": "declarativeAnnexeOrOutstandingCheck",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outstandingAnnexe",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "declarativeAnnexe",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeclarativeAnnexeOrOutstandingCheckMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeclarativeAnnexeOrOutstandingCheckMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3e4fce2a05f5bb4df3e41b39cf958b48",
    "metadata": {},
    "name": "DeclarativeAnnexeOrOutstandingCheckMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "ee6d11f8a1e63eea3f4c5f0480d75841";

export default node;
